import React from "react";
import { Modal } from "@mui/material";
import SubmissionView from "./SubmissionView";

const SingleSubmissionModal = ({ submissionInfo, setSubmissionInfo }) => (
  <Modal
    open={Boolean(submissionInfo)}
    onClose={() => setSubmissionInfo(null)}
    aria-labelledby="View single submission"
    aria-describedby="Modal to view a single submission"
  >
    <div>
      <SubmissionView submissionId={submissionInfo?.id} />
    </div>
  </Modal>
);

export default SingleSubmissionModal;
